import { Checkbox as MuiCheckbox } from '@mui/material';
import { FunctionComponent } from 'react';

import CheckboxProps from './Checkbox.types';

const Checkbox: FunctionComponent<CheckboxProps> = (
  props: CheckboxProps
): JSX.Element => <MuiCheckbox {...props} />;

Checkbox.defaultProps = {
  color: 'primary',
};

export default Checkbox;
